import { Table, TableBody, TableCell, TableHead, TableRow, useTheme } from "@mui/material";
import { IFormLegend } from "../../../services/custom-forms-data-service/TemplateModels";

export type CustomFormLegendProps = {
    legend: IFormLegend
};


export default function CustomFormLegend({legend,
}: CustomFormLegendProps) {

    const theme = useTheme();

     return (

        <Table
            size="small" 
            aria-label='form legend'
            sx={{maxWidth: 300,
                marginTop: theme.spacing(1),
                'td, th': {fontSize: '.8rem'}
            }}
            >
            {/* <caption>{legend.title}</caption> */}
            <TableHead>
          <TableRow>
            <TableCell colSpan={2}>{legend.title}</TableCell>
          </TableRow>
        </TableHead>            
        <TableBody>
          {legend.items.map((o) => (
            <TableRow
              key={o.label}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {o.label}
              </TableCell>
              <TableCell>{o.text}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>        

    );
}
